import { useSelector } from 'react-redux';
import { turboHelper } from '../../../business/order/geoqueue';
import { ordersKanbanSelector } from '../../../redux/selectors/orders-kanban';

export function usePendingToAcceptColumn() {
  const _selectPendingOrders = useSelector(ordersKanbanSelector.pendingOrders);
  const canceledOrders = useSelector(ordersKanbanSelector.canceledOrders) ?? [];

  // TODO: move as pure function or IIFE
  const getSortedPendingOrders = () => {
    const sorted = [
      ..._selectPendingOrders.sort((a, b) =>
        a?.substitution_flow_state ? 1 : b?.substitution_flow_state ? -1 : 0,
      ),
    ];
    return turboHelper.filterV2([...sorted]);
  };

  const showEmpty =
    canceledOrders.length === 0 && _selectPendingOrders.length === 0;

  return {
    pendingOrders: getSortedPendingOrders(),
    canceledOrders,
    showEmpty,
  };
}
